/**
 * Custom error class for handling token refresh errors.
 * This error is thrown when there is an issue refreshing the access token, such as an invalid or expired refresh token.
 */
export class TokenRefreshError extends Error {}
